import styled from 'styled-components';
import { Subtitle as SubtitleOriginal } from 'Styles/links';
import { PanelItem as PanelItemOriginal } from '../../../SlidingPanel';

import Drawer from '../../../Drawer/Drawer';
import IconOriginal from '../../../Icons/Icon';
import LayoutOriginal from '../../../Layout/Layout';

export const NavDrawer = styled(Drawer)`
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow-x: hidden;
`;

export const IconLink = styled.a`
  position: absolute;
  top: 12px;
  left: 24px;
  text-decoration: none;
`;

export const Icon = styled(IconOriginal)`
  color: var(--foreground);
`;

export const PanelItem = styled(PanelItemOriginal)`
  cursor: pointer;
  white-space: nowrap;
  gap: 8px;
`;

export const PanelSubtext = styled.span`
  color: var(--muted-foreground);
  font-weight: 400;
  font-size: 20px;
`;

export const PanelItemsContainer = styled.div`
  padding: 12px 0;
`;

export const RootLinksContainer = styled.div`
  padding: 12px 24px 0 24px;
`;

export const Divider = styled.div`
  display: flex;
  flex: 1;
  border-bottom: 1px solid var(--border);
  margin: 0 8px;
`;

export const PanelLinksContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 8px;
  padding: 20px 24px 0 24px;
`;

export const Subtitle = styled(SubtitleOriginal)`
  padding-top: 8px;
  padding-bottom: 14px;
`;

export const Layout = styled(LayoutOriginal)`
  margin: 4px 0 64px 0;
`;
